import ErrorPageContainer from './error-page.container';

export default ErrorPageContainer;
export { ERROR_TYPE } from './error-page.constants';
